import type { UnitDefinition } from "../types/game-data-config";

export const BASE_UNITS: Readonly<Record<string, UnitDefinition>> = {
  ARCHER: {
    id: "ARCHER",
    coinCount: 4,
    normalMoveAllowed: true,
    normalAttackAllowed: false,
    tacticId: "ARCHER_RANGED",
    attributeId: null,
  },
  BERSERKER: {
    id: "BERSERKER",
    coinCount: 3,
    normalMoveAllowed: true,
    normalAttackAllowed: true,
    tacticId: "BERSERKER_CHARGE",
    attributeId: null,
  },
  CAVALRY: {
    id: "CAVALRY",
    coinCount: 4,
    normalMoveAllowed: true,
    normalAttackAllowed: true,
    tacticId: "CAVALRY_MANEUVER",
    attributeId: null,
  },
  CROSSBOWMAN: {
    id: "CROSSBOWMAN",
    coinCount: 5,
    normalMoveAllowed: true,
    normalAttackAllowed: true,
    tacticId: "CROSSBOWMAN_BOLT",
    attributeId: null,
  },
  ENSIGN: {
    id: "ENSIGN",
    coinCount: 3,
    normalMoveAllowed: true,
    normalAttackAllowed: true,
    tacticId: "ENSIGN_RALLY",
    attributeId: null,
  },
  FOOTMAN: {
    id: "FOOTMAN",
    coinCount: 4,
    normalMoveAllowed: true,
    normalAttackAllowed: true,
    tacticId: "FOOTMAN_FORMATION",
    attributeId: "FOOTMAN_DUAL",
  },
  KNIGHT: {
    id: "KNIGHT",
    coinCount: 4,
    normalMoveAllowed: true,
    normalAttackAllowed: true,
    tacticId: null,
    attributeId: "KNIGHT_ARMOR",
  },
  LANCER: {
    id: "LANCER",
    coinCount: 4,
    normalMoveAllowed: false,
    normalAttackAllowed: false,
    tacticId: "LANCER_THRUST",
    attributeId: null,
  },
  LIGHT_CAVALRY: {
    id: "LIGHT_CAVALRY",
    coinCount: 5,
    normalMoveAllowed: true,
    normalAttackAllowed: true,
    tacticId: "LIGHT_CAVALRY_SWIFT",
    attributeId: null,
  },
  MARSHALL: {
    id: "MARSHALL",
    coinCount: 4,
    normalMoveAllowed: true,
    normalAttackAllowed: true,
    tacticId: "MARSHALL_COMMAND",
    attributeId: null,
  },
  MERCENARY: {
    id: "MERCENARY",
    coinCount: 4,
    normalMoveAllowed: true,
    normalAttackAllowed: true,
    tacticId: null,
    attributeId: "MERCENARY_FREE_MANEUVER",
  },
  PIKEMAN: {
    id: "PIKEMAN",
    coinCount: 4,
    normalMoveAllowed: true,
    normalAttackAllowed: true,
    tacticId: null,
    attributeId: "PIKEMAN_THORNS",
  },
  ROYAL_GUARD: {
    id: "ROYAL_GUARD",
    coinCount: 4,
    normalMoveAllowed: true,
    normalAttackAllowed: true,
    tacticId: "ROYAL_GUARD_PROTECT",
    attributeId: null,
  },
  SCOUT: {
    id: "SCOUT",
    coinCount: 5,
    normalMoveAllowed: true,
    normalAttackAllowed: true,
    tacticId: null,
    attributeId: "SCOUT_FLEXIBLE_DEPLOY",
  },
  SWORDSMAN: {
    id: "SWORDSMAN",
    coinCount: 5,
    normalMoveAllowed: true,
    normalAttackAllowed: true,
    tacticId: null,
    attributeId: "SWORDSMAN_FOLLOW_THROUGH",
  },
  WARRIOR_PRIEST: {
    id: "WARRIOR_PRIEST",
    coinCount: 4,
    normalMoveAllowed: true,
    normalAttackAllowed: true,
    tacticId: null,
    attributeId: "WARRIOR_PRIEST_DRAW",
  },
  ROYAL: {
    id: "ROYAL",
    coinCount: 1,
    normalMoveAllowed: false,
    normalAttackAllowed: false,
    tacticId: null,
    attributeId: null,
  },
};

export const BASE_UNIT_IDS = Object.keys(BASE_UNITS).filter(
  (id) => id !== "ROYAL",
);
